var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card mb-3" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c("div", { staticClass: "custom-control custom-switch mr-3" }, [
          _c("input", {
            staticClass: "custom-control-input",
            attrs: { id: "trigger-active-" + _vm.uid, type: "checkbox" },
            domProps: { checked: _vm.trigger.is_active },
            on: {
              change: function ($event) {
                return _vm.on_toggle_active($event.target.checked)
              },
            },
          }),
          _vm._v(" "),
          _c("label", {
            staticClass: "custom-control-label",
            attrs: { for: "trigger-active-" + _vm.uid },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex-grow-1",
            staticStyle: { cursor: "pointer" },
            on: {
              click: function ($event) {
                _vm.is_expanded = !_vm.is_expanded
              },
            },
          },
          [
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.status_title)),
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "badge badge-pill ml-2", class: _vm.badge_class },
              [_vm._v(_vm._s(_vm.badge_text))]
            ),
          ]
        ),
        _vm._v(" "),
        _vm.trigger.id
          ? _c(
              "button",
              {
                staticClass: "btn btn-icon btn-sm",
                attrs: { title: _vm.__t("DUPLICATE") },
                on: { click: _vm.duplicate },
              },
              [_c("i", { staticClass: "fal fa-copy" })]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-icon btn-sm text-danger",
            attrs: { title: _vm.__t("REMOVE") },
            on: { click: _vm.remove },
          },
          [_c("i", { staticClass: "fal fa-trash-alt" })]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-icon btn-sm",
            attrs: { title: _vm.__t("EXPAND") },
            on: {
              click: function ($event) {
                _vm.is_expanded = !_vm.is_expanded
              },
            },
          },
          [
            _c("i", {
              staticClass: "fal",
              class: _vm.is_expanded ? "fa-chevron-up" : "fa-chevron-down",
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      !_vm.is_expanded && _vm.trigger.message
        ? _c("div", { staticClass: "text-muted small mt-2 text-truncate" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.trigger.message) + "\n        "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.is_expanded
        ? _c("div", { staticClass: "row mt-3" }, [
            _c("div", { staticClass: "col-md-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.__t("EVENT"))),
                  ]),
                  _vm._v(" "),
                  _c("b-form-select", {
                    attrs: { options: _vm.status_options },
                    model: {
                      value: _vm.trigger.trigger_status,
                      callback: function ($$v) {
                        _vm.$set(_vm.trigger, "trigger_status", $$v)
                      },
                      expression: "trigger.trigger_status",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.__t("SEND_AFTER_MINUTES"))),
                  ]),
                  _vm._v(" "),
                  _c("b-form-input", {
                    attrs: { type: "number", min: "0" },
                    model: {
                      value: _vm.trigger.delay_minutes,
                      callback: function ($$v) {
                        _vm.$set(_vm.trigger, "delay_minutes", _vm._n($$v))
                      },
                      expression: "trigger.delay_minutes",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-8" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("h5", { staticClass: "frame-heading mb-3" }, [
                    _vm._v(_vm._s(_vm.__t("MESSAGE"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v(_vm._s(_vm.__t("VARIABLES"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      _vm._l(_vm.variables, function (v) {
                        return _c(
                          "span",
                          {
                            key: v,
                            staticClass:
                              "badge badge-pill badge-light border mr-2 mb-2 px-3 py-2",
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.insert_variable(v)
                              },
                            },
                          },
                          [_vm._v(_vm._s(v))]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group mb-1" },
                    [
                      _c("b-form-textarea", {
                        ref: "message_input",
                        attrs: { rows: "4", "max-rows": "8" },
                        model: {
                          value: _vm.trigger.message,
                          callback: function ($$v) {
                            _vm.$set(_vm.trigger, "message", $$v)
                          },
                          expression: "trigger.message",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(
                      _vm._s((_vm.trigger.message || "").length) +
                        " " +
                        _vm._s(_vm.__t("CHARACTERS"))
                    ),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }